import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import CompalainList from './CompalainList';

function ComplainTableList() {
    return ( 
        <Container>
            <Navbar/>

            <Content>
                <Header/>

             <CompalainList/>
            </Content>
        </Container>
     );
}

export default ComplainTableList;